/**
 * Status Conversion - Asset status filter conversion utilities
 *
 * Converts asset status filters from the status query builder format
 * to QueryFilter format for graph queries.
 *
 * @module queryBuilderCore/utils/statusConversion
 */

import { QueryFilter } from '@/sections/insights/queryBuilder/legacy/types/types';

interface AssetStatusFilter {
  field?: string;
  operator?: string;
  value: unknown;
}

/**
 * Converts asset status filter structure to QueryFilter format
 *
 * @param assetStatusFilter - Status filter from buildAssetStatusFilter
 * @param isNot - Whether to negate the filter
 * @returns QueryFilter representation of the status filter
 */
export function convertAssetStatusFilterToQueryFilter(
  assetStatusFilter: AssetStatusFilter,
  isNot: boolean
): QueryFilter {
  if (assetStatusFilter.field && assetStatusFilter.field !== '') {
    return {
      field: assetStatusFilter.field as string,
      operator: assetStatusFilter.operator as string,
      value: assetStatusFilter.value as string | string[] | QueryFilter[],
      not: isNot,
    };
  }

  if (Array.isArray(assetStatusFilter.value)) {
    const conditions = (assetStatusFilter.value as AssetStatusFilter[]).map(
      condition => {
        if (Array.isArray(condition.value)) {
          return convertAssetStatusFilterToQueryFilter(condition, false);
        }

        return {
          field: condition.field as string,
          operator: condition.operator as string,
          value: condition.value as string | string[] | QueryFilter[],
          not: false,
        };
      }
    );

    return {
      field: '',
      operator: assetStatusFilter.operator as string,
      value: conditions as QueryFilter[],
      not: isNot,
    };
  }

  return {
    field: 'status',
    operator: '=',
    value: 'A',
    not: isNot,
  };
}
